<script lang="ts">
  import { convertStatamicAssetToCDN } from "@utils/cdn";
  import ContentCard from "@components/content/ContentCard.svelte";

  export let title: string;
  export let subtitle: string;
  export let background_image;
  export let background_video_url: string | null;
  export let href: string;
  // TODO: improve css to not need this
  export let disable_aspect_ratio: string = true;

  const backgroundImageUrl = convertStatamicAssetToCDN(background_image?.id);
  // const backgroundVideoUrl = background_video_url?.url;
</script>

<ContentCard
  {...{
    ...$$props,
    backgroundImageUrl,
    backgroundVideoUrl: background_video_url,
    disableAspectRatio: disable_aspect_ratio,
  }}
/>
